import { ReactNode, useMemo } from "react";
import { TrackingAttributesType } from "@claroty/utilities/types/trackingAttributes";
import { useLocation, useRouteMatch } from "react-router-dom";
import { PAGE_NAMES } from "../../app/pageUtils/pageConsts";
import { getPageNameParts } from "../../app/pageUtils/pageUtils";
import TrackingContext from "../TrackingContext";

export type PageTrackingContextProps = {
    trackingPage?: {
        trackingPathName?: string;
        trackingPageSuffix?: string;
    };
    trackingAttributes?: TrackingAttributesType;
    prodTour?: string;

    children: ReactNode;
};
function PageTrackingContext({
    trackingPage: { trackingPathName, trackingPageSuffix = "" } = {},
    trackingAttributes,
    prodTour,

    children,
}: PageTrackingContextProps) {
    const match = useRouteMatch();
    const location = useLocation();

    const nameParts = useMemo(() => getPageNameParts(match.path), [match.path, location.pathname]);
    const trackingPageName = [PAGE_NAMES[trackingPathName ?? match.path], trackingPageSuffix].filter(Boolean).join(" ");

    const allTrackingAttributes = {
        "data-t-page": trackingPageName,
        "data-t-page-path-json": JSON.stringify(nameParts),
        "data-prod-tour": prodTour,
        ...trackingAttributes,
    };

    return <TrackingContext trackingAttributes={allTrackingAttributes}>{children}</TrackingContext>;
}

export default PageTrackingContext;
